(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["notify-me"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('notify-me-block')) {
    customElements.define(
      'notify-me-block',
      class extends HTMLElement {
        connectedCallback() {
          // After a signup the page reloads, possibly on an in-stock variant; still show the confirmation.
          if (this.querySelector('.notify-me__success, .notify-me__error')) this.hidden = false;
          this.onVariantUpdate = (event) => {
            const { resource, data } = event.detail || {};
            if (!resource || (data && data.productId && data.productId !== this.dataset.productId)) return;
            // Keep the confirmation visible after a successful signup.
            if (this.querySelector('.notify-me__success')) return;
            this.hidden = resource.available !== false;
            // Tag the exact variant so the restock workflow only emails people waiting for it.
            const tags = this.querySelector('input[name="contact[tags]"]');
            if (tags && resource.id) {
              tags.value = `${tags.dataset.tagBase}, notify-v-${resource.id}${this.partTags()[resource.id] || ''}`;
            }
          };
          document.addEventListener('variant:update', this.onVariantUpdate);
        }
        partTags() {
          if (!this._partTags) {
            try {
              this._partTags = JSON.parse(this.querySelector('[data-part-tags]')?.textContent || '{}');
            } catch {
              this._partTags = {};
            }
          }
          return this._partTags;
        }
        disconnectedCallback() {
          document.removeEventListener('variant:update', this.onVariantUpdate);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
